import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "252",
        height: "176",
        viewBox: "0 0 252 176",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M56.6581 80.0001C56.6581 98.0925 63.8455 115.444 76.6392 128.237C89.4329 141.03 106.785 148.217 124.878 148.217V160C103.66 160 83.3107 151.572 68.3073 136.569C53.3038 121.566 44.875 101.217 44.875 80.0001H56.6581Z",
                fill: "url(#paint0_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M173.117 31.7631C160.323 18.9699 142.971 11.7827 124.878 11.7827V0C146.096 0 166.445 8.42858 181.448 23.4315C196.452 38.4344 204.881 58.7827 204.881 80C204.881 101.217 196.452 121.566 181.448 136.569C166.445 151.571 146.096 160 124.878 160V148.217C142.971 148.217 160.323 141.03 173.117 128.237C185.91 115.444 193.098 98.0924 193.098 80C193.098 61.9076 185.91 44.5563 173.117 31.7631Z",
                fill: "url(#paint1_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M124.878 11.7827C106.785 11.7827 89.4329 18.9699 76.6392 31.7631C63.8455 44.5563 56.6581 61.9076 56.6581 80H44.875C44.875 58.7827 53.3038 38.4344 68.3073 23.4315C83.3107 8.42858 103.66 0 124.878 0V11.7827Z",
                fill: "url(#paint2_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M67.7215 69.3321C61.8332 100.886 82.6402 131.238 114.195 137.126C145.75 143.014 176.104 122.208 181.992 90.6545C187.88 59.1007 167.073 28.7481 135.518 22.8601C103.963 16.972 73.6097 37.7783 67.7215 69.3321ZM113.801 139.236C81.0812 133.131 59.5059 101.657 65.6116 68.9384C71.7173 36.2194 103.192 14.6448 135.912 20.7503C168.632 26.8557 190.208 58.3292 184.102 91.0482C177.996 123.767 146.522 145.342 113.801 139.236Z",
                fill: "url(#paint3_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.5656 26.7354L28.7901 19.4143L31.4829 29.4635L21.5656 26.7354ZM35.9067 45.9729L26.2741 55.7344L13.0511 52.0969L9.90949 40.3728L23.1325 44.0103L32.7652 34.2488L35.9067 45.9729ZM5.93442 25.5382L15.8517 28.2663L8.62721 35.5874L5.93442 25.5382ZM20.7783 29.5108L30.6955 32.2389L23.4711 39.56L20.7783 29.5108ZM20.6141 40.3255L10.6968 37.5974L17.9213 30.2763L20.6141 40.3255ZM26.7205 17.4043L18.2599 25.826L6.72177 22.7628L15.1183 14.1019L26.7205 17.4043ZM2.17987 22.9539L10.5788 54.298L27.0435 58.6056L39.1484 46.6431L30.7495 15.299L14.2848 10.9914L2.17987 22.9539Z",
                fill: "url(#paint4_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M114.978 51.8968L113.355 53.5173C113.355 53.5173 110.848 51.681 109.825 49.7734C108.939 48.1199 108.725 45.4838 108.725 45.4838C108.725 45.4838 111.095 46.1188 112.17 45.7862C113.157 45.4811 113.466 45.2529 113.466 45.2529C113.466 45.2529 113.04 49.137 114.978 51.8968ZM149.878 78.4096C150.201 76.4016 148.931 73.6308 148.931 73.6308C151.563 73.793 152.553 76.2889 152.553 78.367C152.553 80.4451 151.213 82.8009 149.596 84.3237C147.98 85.8466 147.612 87.533 147.612 87.533C146.976 85.7943 147.311 84.8837 147.69 83.8546C148.041 82.9012 148.43 81.8461 148.119 79.9366C147.805 77.9849 146.489 76.4786 145.232 75.4519C144.644 75.8047 143.985 76.2705 143.251 76.7889C138.716 79.9927 131.346 85.2003 120.382 78.0798C109.77 71.1874 107.004 72.3282 105.183 73.0787C104.819 73.229 104.492 73.3637 104.148 73.415C105.15 73.4833 106.146 73.6258 107.127 73.8411C107.127 73.8411 102.348 75.9632 101.701 79.9339C101.389 81.8434 101.778 82.8985 102.129 83.8519C102.508 84.881 102.843 85.7915 102.208 87.5302C102.208 87.5302 101.841 85.8493 100.224 84.3251C98.608 82.8009 97.2679 80.4465 97.2679 78.3684C97.2679 76.2903 98.2616 73.7971 100.894 73.6349C100.894 73.6349 99.6237 76.4058 99.9467 78.4138C99.9467 78.4138 101.013 74.6987 102.309 73.7037L101.736 72.244C104.752 70.5994 107.971 69.3595 111.311 68.5565C111.311 68.5565 108.169 67.123 102.579 69.142L101.684 66.0125C107.766 63.0602 114.119 61.8796 120.915 61.7216C120.915 61.7216 113.471 59.7534 104.147 62.5861C104.134 62.2718 104.105 62.0461 104.082 61.8661C104.038 61.5267 104.015 61.3499 104.158 61.0481C104.269 60.8377 104.417 60.6488 104.594 60.4901C104.73 60.376 107.002 58.5618 113.712 57.8457C113.712 57.8457 111.041 56.7599 106.368 57.5997C106.559 56.0659 107.018 54.565 108.943 54.1527C110.732 53.7761 111.54 54.1676 112.855 54.805C113.475 55.1051 114.206 55.4597 115.206 55.8143C116.496 56.2713 118.401 56.2778 120.167 56.2838C120.897 56.2863 121.604 56.2887 122.234 56.3229C116.409 55.7085 113.642 53.8077 113.642 53.8077C113.642 53.8077 114.791 52.355 116.168 51.9206C116.595 51.7859 117.068 51.7322 117.584 51.6735C118.732 51.5431 120.099 51.3878 121.68 50.2617C123.972 48.6289 125.941 48.8062 125.941 48.8062C125.941 48.8062 127.905 48.6289 130.201 50.2617C131.785 51.3876 133.152 51.5431 134.299 51.6735C134.816 51.7322 135.288 51.7858 135.714 51.9206C136.848 52.2766 137.827 53.3253 138.137 53.6854C138.854 53.4462 139.589 53.3816 140.709 53.618C142.424 53.9795 143.099 56.3325 143.363 57.9268C141.854 57.6134 138.089 57.1461 130.522 57.8457C130.522 57.8457 139.021 58.3103 143.962 60.4777C144.476 60.7911 145.15 61.2735 145.382 61.7642C145.775 62.5957 145.671 64.8621 145.671 64.8621L148.05 66.0166L147.278 69.1928C147.278 69.1928 138.001 64.9583 124.867 66.1128C124.867 66.1128 138.425 65.9218 147.496 71.4194L148.142 71.8812L147.443 73.6473C148.772 74.5613 149.878 78.4096 149.878 78.4096ZM116.022 111.146C114.774 110.754 113.737 109.438 113.737 109.438C113.737 109.438 117.292 106.991 124.866 106.991C132.439 106.991 135.999 109.438 135.999 109.438C135.999 109.438 134.96 110.762 133.713 111.156C133.326 111.278 132.899 111.326 132.432 111.379C131.395 111.497 130.16 111.637 128.726 112.656C126.648 114.134 124.868 113.973 124.868 113.973C124.868 113.973 123.086 114.124 121.009 112.647C119.575 111.627 118.339 111.487 117.301 111.369L117.301 111.369C116.835 111.316 116.409 111.267 116.022 111.146ZM155.81 67.9833C153.075 66.4508 148.586 66.1567 148.586 66.1567L147.863 69.3976C152.375 71.2599 154.88 76.3301 154.88 76.3301C154.88 76.3301 155.08 75.8119 156.048 74.6712C157.102 73.4342 160.489 72.3649 160.489 72.3649C160.489 72.3649 158.178 69.3055 155.81 67.9833ZM148.805 106.262C148.805 106.262 148.658 106.596 148.578 107.577C148.49 108.644 149.572 110.714 149.572 110.714C149.572 110.714 147.079 111.06 145.361 110.576C143.769 110.127 142.023 108.784 141.395 108.27C141.179 108.386 140.948 108.471 140.708 108.522C138.917 108.898 138.109 108.506 136.795 107.868C136.177 107.568 135.447 107.213 134.45 106.859C131.334 105.751 124.867 105.728 124.867 105.728C124.867 105.728 118.403 105.741 115.286 106.855C114.294 107.209 113.566 107.562 112.949 107.861C111.63 108.501 110.823 108.892 109.028 108.518C107.103 108.112 106.693 106.409 106.502 104.874C111.171 105.715 113.715 104.29 113.715 104.29C107.005 103.57 104.734 101.758 104.597 101.646C104.419 101.487 104.272 101.297 104.161 101.086C103.984 100.711 104 100.437 104.032 99.8569L104.032 99.8568C104.04 99.7247 104.048 99.5766 104.055 99.408C113.378 102.241 120.921 100.414 120.921 100.414C114.125 100.256 107.772 99.0754 101.69 96.1217L102.618 92.6472C108.445 94.1082 111.317 93.5777 111.317 93.5777C107.977 92.775 104.758 91.5351 101.744 89.8902L102.475 88.0402C111.894 91.8886 137.853 91.8886 147.272 88.0402L148.149 90.2571L147.503 90.7189C138.435 96.218 124.874 96.0255 124.874 96.0255C138.002 97.1814 147.278 92.9455 147.278 92.9455L148.052 96.1245L145.673 97.2804C145.673 97.2804 145.974 100.257 145.581 101.089C145.348 101.58 144.675 102.062 144.161 102.375C139.22 104.55 130.522 104.299 130.522 104.299C138.095 105 141.793 105.079 143.304 104.765C145.066 105.5 146.915 106.003 148.805 106.262ZM99.9009 84.8255C95.3941 86.6988 90.0378 84.8832 90.0378 84.8832C90.0378 84.8832 90.2618 85.3863 90.3869 86.883C90.5244 88.5048 88.875 91.6549 88.875 91.6549C88.875 91.6549 92.6671 92.1813 95.2814 91.4446C98.3052 90.5939 101.682 87.6279 101.682 87.6279L99.9009 84.8255ZM110.8 80.3457C110.8 80.3457 109.596 83.232 111.953 84.392C114.31 85.552 120.236 84.9637 120.236 84.9637C120.236 84.9637 115.099 81.1786 110.8 80.3457ZM138.629 86.2239C140.614 85.7153 140.152 83.3142 140.152 83.3142L140.154 83.3142C136.735 83.2689 132.211 85.347 132.211 85.347C132.211 85.347 136.645 86.7324 138.629 86.2239Z",
                fill: "#C6FFEE"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M211.378 130.652C209.108 129.737 207.466 128.451 206.452 126.796C205.459 125.131 205.373 123.281 206.182 121.275C206.355 120.846 206.604 120.359 206.942 119.783C207.742 118.503 208.759 116.991 210 115.23C213.419 110.484 217.832 109.201 223.223 111.375C224.685 111.965 225.912 112.744 226.865 113.716C227.831 114.658 228.449 115.761 228.724 117.012C229.005 118.247 228.877 119.53 228.339 120.863C228.179 121.261 227.929 121.748 227.591 122.323C226.616 123.907 225.608 125.441 224.548 126.883C222.822 129.231 220.883 130.746 218.714 131.384C216.565 132.014 214.119 131.757 211.378 130.652ZM213.456 126.683C214.522 127.113 215.55 127.153 216.55 126.826C217.565 126.506 218.502 125.762 219.353 124.574C220.523 122.945 221.488 121.518 222.26 120.263C222.497 119.895 222.709 119.5 222.882 119.071C223.586 117.326 223.039 116.09 221.227 115.36C220.161 114.93 219.117 114.883 218.103 115.204C217.103 115.53 216.181 116.28 215.33 117.468C214.461 118.613 213.496 120.04 212.393 121.767C212.162 122.119 211.956 122.499 211.783 122.928C211.051 124.698 211.628 125.946 213.456 126.683Z",
                fill: "url(#paint5_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M223.757 135.642C223.543 135.556 223.415 135.433 223.348 135.246C223.319 135.056 223.356 134.876 223.467 134.689L234.945 117.624C235.062 117.422 235.237 117.297 235.476 117.233C235.699 117.163 235.907 117.176 236.105 117.256L243.723 120.328C245.845 121.183 247.361 122.31 248.292 123.699C249.232 125.11 249.376 126.644 248.704 128.311C248.513 128.785 248.248 129.265 247.932 129.742C246.57 131.754 244.955 132.987 243.063 133.452C241.203 133.928 239.024 133.654 236.52 132.645L232.658 131.087L228.81 136.844C228.678 137.04 228.518 137.171 228.279 137.235C228.056 137.305 227.848 137.292 227.65 137.212L223.757 135.642ZM238.316 128.763C239.125 129.09 239.898 129.152 240.673 128.949C241.462 128.752 242.112 128.285 242.644 127.539C242.834 127.242 242.982 126.964 243.081 126.719C243.303 126.169 243.307 125.673 243.104 125.253C242.907 124.817 242.404 124.437 241.625 124.123L238.19 122.738L235.034 127.44L238.316 128.763Z",
                fill: "url(#paint6_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M43.2601 150.318L44.0125 154.827C44.0309 154.954 44.0968 155.068 44.197 155.148L50.2572 160.162L52.1152 157.02L43.7045 150.062C43.5099 149.9 43.2175 150.069 43.2601 150.318Z",
                fill: "url(#paint7_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M42.4291 142.479C42.2345 142.317 41.9422 142.486 41.9848 142.735L42.7371 147.245C42.7555 147.371 42.8214 147.486 42.9217 147.565L52.8481 155.774L54.7062 152.632L42.4291 142.479Z",
                fill: "url(#paint8_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M32.8555 137.174C32.9257 137.134 32.9999 137.114 33.084 137.111L47.0029 136.988C47.1653 136.986 47.3138 137.068 47.3928 137.205L54.2261 149.063C54.3052 149.2 54.3017 149.37 54.2184 149.509L47.1361 161.496C47.0974 161.564 47.0371 161.621 46.9669 161.662C46.8968 161.702 46.8225 161.722 46.7385 161.725L32.8254 161.845C32.663 161.847 32.5145 161.765 32.4355 161.628L25.5988 149.764C25.5198 149.627 25.5233 149.457 25.6066 149.318L32.6922 137.337C32.7309 137.269 32.7912 137.211 32.8555 137.174ZM31.8572 135.442C31.483 135.657 31.1647 135.97 30.9401 136.351L23.8545 148.332C23.4053 149.094 23.3921 150.03 23.827 150.785L30.6603 162.643C31.0952 163.398 31.9157 163.862 32.7998 163.855L46.7186 163.732C47.1607 163.728 47.591 163.61 47.9652 163.394C48.3394 163.178 48.6577 162.866 48.8823 162.485L55.9679 150.504C56.423 149.739 56.4303 148.805 55.9921 148.045L49.1588 136.187C48.7239 135.433 47.9035 134.969 47.0193 134.975L33.1096 135.101C32.6617 135.108 32.2314 135.226 31.8572 135.442Z",
                fill: "url(#paint9_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M35.1209 143.148L32.4603 144.681C32.2615 144.795 32.1493 145.02 32.1905 145.24L35.2999 163.829L38.9503 163.797L35.5269 143.325C35.4938 143.146 35.2905 143.05 35.1209 143.148Z",
                fill: "url(#paint10_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M39.7813 140.464L37.1207 141.998C36.9219 142.112 36.8097 142.337 36.8509 142.557L40.3995 163.786L44.0499 163.754L40.1847 140.651C40.1542 140.463 39.9451 140.37 39.7813 140.464Z",
                fill: "url(#paint11_linear_48_4405)"
            }),
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_48_4405)",
                children: /*#__PURE__*/ _jsx("g", {
                    clipPath: "url(#clip1_48_4405)",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M217.43 28.4905C224.285 30.5477 231.506 26.6685 233.56 19.826C235.613 12.9836 231.721 5.76905 224.867 3.71188C218.364 1.76015 211.531 5.1518 209.094 11.3479L225.498 16.2713L224.873 18.3541L208.468 13.4307C207.091 19.9448 210.927 26.5388 217.43 28.4905Z",
                        fill: "url(#paint12_linear_48_4405)"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_48_4405",
                        x1: "44.8643",
                        y1: "119.995",
                        x2: "124.878",
                        y2: "119.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_48_4405",
                        x1: "124.867",
                        y1: "79.9893",
                        x2: "204.881",
                        y2: "79.9893",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_48_4405",
                        x1: "44.8643",
                        y1: "39.9946",
                        x2: "124.878",
                        y2: "39.9946",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint3_linear_48_4405",
                        x1: "113.791",
                        y1: "139.251",
                        x2: "135.903",
                        y2: "20.7485",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint4_linear_48_4405",
                        x1: "6.37465",
                        y1: "38.6238",
                        x2: "34.9479",
                        y2: "30.9673",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint5_linear_48_4405",
                        x1: "207.825",
                        y1: "117.191",
                        x2: "226.743",
                        y2: "124.82",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint6_linear_48_4405",
                        x1: "227.215",
                        y1: "125.352",
                        x2: "246.725",
                        y2: "133.219",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint7_linear_48_4405",
                        x1: "44.7995",
                        y1: "156.266",
                        x2: "49.9651",
                        y2: "153.289",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint8_linear_48_4405",
                        x1: "44.6967",
                        y1: "150.718",
                        x2: "51.3829",
                        y2: "146.865",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint9_linear_48_4405",
                        x1: "27.2408",
                        y1: "156.717",
                        x2: "52.576",
                        y2: "142.117",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint10_linear_48_4405",
                        x1: "31.2505",
                        y1: "156.804",
                        x2: "40.3052",
                        y2: "151.586",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint11_linear_48_4405",
                        x1: "35.7239",
                        y1: "155.676",
                        x2: "45.5878",
                        y2: "149.992",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint12_linear_48_4405",
                        x1: "208.778",
                        y1: "12.3866",
                        x2: "233.56",
                        y2: "19.8244",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#BCFFEB",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E6FFF8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_48_4405",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "26.0977",
                            height: "26.0977",
                            fill: "white",
                            transform: "translate(212.499) rotate(16.7059)"
                        })
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip1_48_4405",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "26.0977",
                            height: "26.0977",
                            fill: "white",
                            transform: "translate(212.499) rotate(16.7059)"
                        })
                    })
                ]
            })
        ]
    }));
};
export default Icon;
